import {platform} from '../../platform';

export const getVideoMeta = async (file: File) => {
  if (platform.isNative) {
    throw new Error('Not supported');
  }

  const video = document.createElement('video');

  video.preload = 'metadata';
  video.src = URL.createObjectURL(file);

  const duration = await new Promise<number>(resolve => {
    video.onloadedmetadata = () => {
      resolve(video.duration);
    };
  });

  return {
    duration,
    size: file.size,
  };
};
